import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import ReengagementIllustrationImage from '../../assets/notetaker-reengagement-illustration.png';
const illustrationImageCss = "i19j5fkf";
export const ReengagementIllustration = () => {
  const isPhone = useDeviceType('isPhone');
  if (isPhone) {
    return null;
  }
  return <img src={ReengagementIllustrationImage} alt="" className={illustrationImageCss} data-testid="notetaker-reengagement-illustration" />;
};

require("./reengagement_illustration.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./reengagement_illustration.js");